// eslint-disable-next-line no-restricted-imports
import * as S from './styled';

const BusyIndicator = ({ ...props }) => <S.BusyIndicator data-testid="busyIndicator" {...props} />;

export default BusyIndicator;
